import * as React from 'react';
import { SVGProps } from 'react';

const SvgGooglePlay = (props: SVGProps) => {
  return (
    <svg
      width={120}
      height={36}
      viewBox="0 0 120 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M115.556 36H4.444C1.956 36 0 34.02 0 31.5v-27C0 1.98 1.956 0 4.444 0h111.112C118.044 0 120 1.98 120 4.5v27c0 2.52-1.956 4.5-4.444 4.5Z"
        fill="#fff"
      />
      <path
        d="M115.556.72c2.044 0 3.733 1.71 3.733 3.78v27c0 2.07-1.689 3.78-3.733 3.78H4.444C2.4 35.28.711 33.57.711 31.5v-27C.711 2.43 2.4.72 4.444.72h111.112Zm0-.72H4.444C1.956 0 0 2.07 0 4.5v27C0 34.02 1.956 36 4.444 36h111.112c2.488 0 4.444-1.98 4.444-4.5v-27c0-2.43-1.956-4.5-4.444-4.5Z"
        fill="#000"
      />
      <path
        d="M60.533 19.62c-2.133 0-3.822 1.62-3.822 3.87 0 2.16 1.689 3.87 3.822 3.87 2.134 0 3.823-1.62 3.823-3.87 0-2.34-1.69-3.87-3.823-3.87Zm0 6.12c-1.155 0-2.133-.99-2.133-2.34 0-1.35.978-2.34 2.133-2.34 1.156 0 2.134.9 2.134 2.34 0 1.35-.978 2.34-2.134 2.34Zm-8.266-6.12c-2.134 0-3.823 1.62-3.823 3.87 0 2.16 1.69 3.87 3.823 3.87s3.822-1.62 3.822-3.87c0-2.34-1.689-3.87-3.822-3.87Zm0 6.12c-1.156 0-2.134-.99-2.134-2.34 0-1.35.978-2.34 2.134-2.34 1.155 0 2.133.9 2.133 2.34 0 1.35-.978 2.34-2.133 2.34ZM42.4 20.79v1.62h3.822c-.089.9-.444 1.62-.889 2.07-.533.54-1.422 1.17-2.933 1.17-2.4 0-4.178-1.89-4.178-4.32 0-2.43 1.867-4.32 4.178-4.32 1.244 0 2.222.54 2.933 1.17l1.156-1.17c-.978-.9-2.222-1.62-4-1.62-3.2 0-5.956 2.7-5.956 5.94s2.756 5.94 5.956 5.94c1.778 0 3.022-.54 4.089-1.71C47.644 24.48 48 22.95 48 21.78c0-.36 0-.72-.089-.99H42.4Zm40.355 1.26c-.355-.9-1.244-2.43-3.2-2.43C77.6 19.62 76 21.15 76 23.49c0 2.16 1.6 3.87 3.733 3.87 1.69 0 2.756-1.08 3.111-1.71l-1.244-.9c-.444.63-.978 1.08-1.867 1.08s-1.422-.36-1.866-1.17l5.066-2.16-.178-.45ZM77.6 23.31c0-1.44 1.156-2.25 1.956-2.25.622 0 1.244.36 1.422.81L77.6 23.31ZM73.422 27h1.69V15.75h-1.69V27Zm-2.666-6.57c-.445-.45-1.156-.9-2.045-.9-1.867 0-3.644 1.71-3.644 3.87s1.689 3.78 3.644 3.78c.889 0 1.6-.45 1.956-.9h.088v.54c0 1.44-.8 2.25-2.044 2.25-.978 0-1.689-.72-1.867-1.35l-1.422.63c.445.99 1.511 2.25 3.378 2.25 1.956 0 3.556-1.17 3.556-3.96V19.8h-1.6v.63ZM68.8 25.74c-1.156 0-2.133-.99-2.133-2.34 0-1.35.977-2.34 2.133-2.34 1.156 0 2.044.99 2.044 2.34 0 1.35-.888 2.34-2.044 2.34Zm21.689-9.99h-4V27h1.689v-4.23h2.31c1.868 0 3.645-1.35 3.645-3.51 0-2.16-1.777-3.51-3.644-3.51Zm.089 5.4h-2.4v-3.87h2.4c1.244 0 1.955 1.08 1.955 1.89-.089.99-.8 1.98-1.955 1.98Zm10.222-1.62c-1.245 0-2.489.54-2.933 1.71l1.51.63c.356-.63.89-.81 1.512-.81.889 0 1.689.54 1.778 1.44v.09c-.267-.18-.978-.45-1.689-.45-1.6 0-3.2.9-3.2 2.52 0 1.53 1.333 2.52 2.755 2.52 1.156 0 1.689-.54 2.134-1.08h.089v.9h1.6v-4.32c-.178-1.98-1.689-3.15-3.556-3.15Zm-.178 6.21c-.533 0-1.333-.27-1.333-.99 0-.9.978-1.17 1.778-1.17.711 0 1.066.18 1.511.36-.178 1.08-1.067 1.8-1.956 1.8Zm9.334-5.94-1.867 4.86H108l-1.956-4.86h-1.777l2.933 6.84-1.689 3.78h1.689l4.533-10.62h-1.777ZM95.022 27h1.69V15.75h-1.69V27Z"
        fill="#000"
      />
      <path
        d="M9.244 6.75c-.266.27-.355.72-.355 1.26V27.9c0 .54.178.99.444 1.26l.09.09 11.021-11.16v-.18L9.244 6.75Z"
        fill="url(#a)"
      />
      <path
        d="m24 21.87-3.644-3.69v-.27L24 14.22l.089.09 4.355 2.52c1.245.72 1.245 1.89 0 2.61L24 21.87Z"
        fill="url(#b)"
      />
      <path
        d="M24.089 21.78 20.356 18 9.244 29.25c.445.45 1.067.45 1.867.09l12.978-7.56Z"
        fill="url(#c)"
      />
      <path
        d="M24.089 14.22 11.11 6.75c-.8-.45-1.422-.36-1.867.09L20.356 18l3.733-3.78Z"
        fill="url(#d)"
      />
      <path
        opacity={0.2}
        d="m24 21.69-12.889 7.38c-.711.45-1.333.36-1.778 0l-.089.09.09.09c.444.36 1.066.45 1.777 0L24 21.69Z"
        fill="#000"
      />
      <path
        opacity={0.12}
        d="M9.244 29.07c-.266-.27-.355-.72-.355-1.26v.09c0 .54.178.99.444 1.26v-.09h-.089ZM28.444 19.17 24 21.69l.089.09 4.355-2.52c.623-.36.89-.81.89-1.26 0 .45-.356.81-.89 1.17Z"
        fill="#000"
      />
      <path
        opacity={0.25}
        d="m11.111 6.84 17.333 9.99c.534.36.89.72.89 1.17 0-.45-.267-.9-.89-1.26L11.111 6.75C9.867 6.03 8.89 6.57 8.89 8.01v.09c0-1.35.978-1.98 2.222-1.26Z"
        fill="#fff"
      />
      <path
        d="M37.422 12.87H36.8v-1.8h.533c.445-.36.711-1.08.711-2.07V6.3H41.6v4.77h.622v1.8H41.6V11.7h-4.089v1.17h-.089ZM38.667 9c0 .81-.178 1.53-.534 2.07H40.8V6.93h-2.222V9h.089ZM47.467 10.98c-.534.54-1.156.81-1.956.81s-1.422-.27-1.955-.81c-.534-.54-.8-1.17-.8-1.98s.266-1.44.8-1.98c.533-.54 1.155-.81 1.955-.81s1.422.27 1.956.81c.533.54.8 1.17.8 1.98s-.267 1.44-.8 1.98Zm-3.378-.45c.355.36.889.63 1.422.63.533 0 1.067-.18 1.422-.63.356-.36.623-.9.623-1.53s-.178-1.17-.623-1.53c-.355-.36-.889-.63-1.422-.63-.533 0-1.067.18-1.422.63-.356.36-.622.9-.622 1.53s.177 1.17.622 1.53ZM51.733 11.79c-.8 0-1.422-.27-1.955-.81-.534-.54-.8-1.17-.8-1.98s.266-1.44.8-1.98c.533-.54 1.155-.81 1.955-.81s1.423.27 1.956.9l-.445.45a1.89 1.89 0 0 0-1.51-.72c-.623 0-1.067.18-1.512.63-.444.36-.622.9-.622 1.53s.178 1.17.622 1.53c.356.36.89.63 1.511.63.623 0 1.156-.27 1.6-.81l.445.45c-.267.27-.534.54-.89.72-.355.18-.71.27-1.155.27ZM56.622 11.7h-.71V6.93H54.4V6.3h3.644v.63h-1.51v4.77h.088ZM62.756 6.3l-2.045 4.59c-.267.63-.711.99-1.244.99-.178 0-.356 0-.534-.09l.178-.63c.089.09.267.09.356.09.177 0 .266 0 .355-.09.09-.09.178-.18.267-.36l.178-.45-1.778-3.96h.8l1.333 3.06 1.334-3.15h.8ZM63.556 11.7V6.3h3.822v5.4h-.711V6.93h-2.49v4.77h-.622ZM68.622 11.7V6.3h.711v2.34H72V6.3h.711v5.4H72V9.27h-2.667v2.43h-.71ZM78.311 10.98c-.533.54-1.156.81-1.956.81s-1.422-.27-1.955-.81c-.533-.54-.8-1.17-.8-1.98s.267-1.44.8-1.98 1.155-.81 1.956-.81c.8 0 1.422.27 1.955.81.533.54.8 1.17.8 1.98-.089.81-.356 1.44-.8 1.98Zm-3.467-.45c.356.36.89.63 1.423.63s1.066-.18 1.422-.63c.355-.36.622-.9.622-1.53s-.178-1.17-.622-1.53c-.356-.36-.889-.63-1.422-.63-.534 0-1.067.18-1.423.63-.355.36-.622.9-.622 1.53s.267 1.17.622 1.53ZM81.867 11.7V6.3h1.955c.445 0 .8.18 1.067.45.267.27.444.63.444.99 0 .27-.089.45-.177.72a.913.913 0 0 1-.534.45c.267.09.445.27.622.45.178.18.267.45.267.81 0 .45-.178.81-.444 1.08-.356.27-.711.45-1.156.45h-2.044Zm.71-3.06h1.245c.267 0 .445-.09.622-.27.178-.18.267-.36.267-.54 0-.18-.178-.45-.267-.63-.177-.18-.355-.27-.622-.27h-1.244v1.71Zm0 2.43H84c.267 0 .444-.09.622-.27a.822.822 0 0 0 .267-.63c0-.18-.089-.45-.267-.63-.178-.18-.355-.27-.622-.27h-1.333v1.8h-.09Z"
        fill="#000"
        strokeMiterlimit={10}
      />
      <defs>
        <linearGradient
          id="a"
          x1={19.377}
          y1={7.839}
          x2={4.274}
          y2={22.755}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="b"
          x1={30.075}
          y1={18.001}
          x2={8.567}
          y2={18.001}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={22.068}
          y1={20.067}
          x2={1.587}
          y2={40.295}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={6.486}
          y1={0.159}
          x2={15.632}
          y2={9.191}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgGooglePlay;
